module.exports = __webpack_public_path__ + "static/media/application_2.642adb9a.png";